/*=========================================================================================
  File Name: moduleRecueil.js
  Description: Recueil Module
==========================================================================================*/


import state from './moduleRecueilState.js';
import mutations from './moduleRecueilMutations.js';
import actions from './moduleRecueilActions.js';
import getters from './moduleRecueilGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
};